export default __webpack_public_path__ + "static/media/noimage.52e869e4.jpg";